module.exports = __webpack_public_path__ + "assets/current-year.0315fd67.svg";